import { styled } from "styled-components";

const FixtureCard = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 2rem;
  align-items: center;
  
  .team {
    text-align: center;
    
    .logo-container {
      margin-bottom: 0.5rem;
      display: flex;
      justify-content: center;
    }
  }
  
  .details {
    text-align: center;
    
    .date {
      color: var(--primary);
      font-weight: bold;
      margin-bottom: 0.5rem;
    }
    
    .time {
      color: var(--gray);
    }
    
    .venue {
      margin-top: 0.5rem;
      font-size: 0.9rem;
    }
  }
`;

export { FixtureCard };